module.exports = __webpack_public_path__ + "static/media/eiga_kanji.17dfeddb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_img/eiga_kanji.svg
// module id = 240
// module chunks = 0